/**
 * Combines multiple sets into a single set.
 */
export default function mergeSets<T>(sets: Set<T>[]) {
  const set = new Set<T>();

  sets.forEach((s) => {
    s.forEach((v) => {
      set.add(v);
    });
  });

  return set;
}
